import React, { useState } from "react";

import {
  Card,
  MessageBar,
  MessageBarType,
  Spinner,
  Stack
} from "@bps/fluent-ui";
import { routes } from "@libs/routing/routes.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { LocationDetailsForm } from "../location-details/LocationDetailsForm.tsx";
import { LocationStatusButtons } from "./LocationStatusButtons.tsx";
import { fetchOrgUnitScreenData } from "./utils.ts";

const LocationDetailsScreen: React.FC = () => {
  const { routing } = useStores();
  const [
    showNeedToConfigWorkingHoursMessageBar,
    setShowNeedToConfigWorkingHoursMessageBar
  ] = useState(false);

  const locationId = routing.match(routes.settings.practices.locations.edit)
    ?.params.id;

  return (
    <Stack styles={{ root: { paddingTop: 24 } }} tokens={{ childrenGap: 24 }}>
      <DataFetcher
        fetch={async root =>
          locationId ? fetchOrgUnitScreenData(root, locationId) : undefined
        }
        fallback={<Spinner />}
      >
        {data => (
          <Card
            id="new-location-details-card"
            iconName="Nav2DMapView"
            headingLevel="section-heading"
            heading="Location"
            button={
              data && (
                <LocationStatusButtons
                  {...data}
                  onReactivate={() =>
                    setShowNeedToConfigWorkingHoursMessageBar(true)
                  }
                />
              )
            }
            styles={{
              subComponentStyles: {
                tile: {
                  content: {
                    padding: 0
                  }
                }
              }
            }}
          >
            {showNeedToConfigWorkingHoursMessageBar && (
              <MessageBar
                messageBarType={MessageBarType.warning}
                onDismiss={() =>
                  setShowNeedToConfigWorkingHoursMessageBar(false)
                }
              >
                Please configure new working hours for providers working at this
                location
              </MessageBar>
            )}
            <LocationDetailsForm
              pracOrgUnit={data?.pracOrgUnit}
              locationOrgUnit={data?.orgUnit}
            />
          </Card>
        )}
      </DataFetcher>
    </Stack>
  );
};

// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default LocationDetailsScreen;
